import React from 'react';
import { useDateUtils } from '../_hooks';
var DateField = function (props) {
    var id = props.id, isValid = props.isValid, max = props.max, min = props.min, pattern = props.pattern, readOnly = props.readOnly, required = props.required, value = props.value, onChange = props.onChange;
    var isValidDate = useDateUtils().isValidDate;
    return (React.createElement("input", { className: "form-control" + (isValid && isValidDate(value) ? '' : ' is-invalid'), value: value, id: id, max: max, min: min, pattern: pattern != null ? pattern : '[0-9]{4}-[0-9]{2}-[0-9]{2}', readOnly: readOnly, required: required, type: "date", onChange: onChange }));
};
export default React.memo(DateField);
